export const changeRecaptchaError = (type) => {
  const iframe = document.querySelector('iframe[role="presentation"]');
  if (iframe) iframe.classList[type]("error");
};

export const scrollToElement = (q) => {
  const el = document.querySelector(q);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
};
